import { NUDGES_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

export interface INudgesPayloadProps {
  customer_id: string;
  pet_id: string;
  booking_id?: string;
  journey_point: string;
  alert_category_list: Array<string>;
  role_id: string;
  cart_id: string;
  service_id?: string;
  sub_service_id?: string;
  clinic_id?: string;
  emr_id?: string;
  booking_list?: string;
  doctor_id?: string;
  slot_start_time?: string;
  slot_end_time?: string;
}

export type INudgeList = {
  status: boolean;
  message: any;
};

//192.168.8.191:8010/vms/v1/nudges/list/
AxiosCurlirize(axios, () => {});

export const useNudgesAlertAPI = () => {
  const [nudges, setNudges] = useState<any>(null);

  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (nudgeBody: INudgesPayloadProps) => {
      try {
        dispatch(
          setLoading({
            key: "isNudgeLoadingInpogress",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: INudgeList = await axios
          .post(`${NUDGES_APIS?.NUDGES_ALERT?.baseURL}`, nudgeBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            console.log("Nudges Alert Response", res);
            if (res.status === 200 || res.status === 201) {
              dispatch(
                setLoading({
                  key: "isNudgeLoadingInpogress",
                  status: false,
                }),
              );
              setNudges(res.data?.data?.length > 0 ? res.data.data[0] : null);
              return { status: true, message: res.data?.data?.length > 0 ? res.data.data[0] : [] };
              //
            } else {
              setNudges(null);
              return { status: false, message: "" };
            }
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isNudgeLoadingInpogress",
                status: false,
              }),
            );
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              setNudges(null);
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              setNudges(null);
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              setNudges(null);
              toast.error("Server error 500");
            }
            return { status: false, message: "" };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isNudgeLoadingInpogress",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
        setNudges(null);
      }
    },
    [dispatch],
  );
  return { execute, nudges };
};
